import { api } from "../../api"
import { createAsyncThunk } from "@reduxjs/toolkit"

export const loadStats = createAsyncThunk("stats/all", async () => {
  return await api().loadStats()
})
